var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-loading"},[(_vm.displayVisable)?_c('img',{attrs:{"src":_vm.loadingGif,"alt":"","srcset":""}}):[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }